import { getAccessToken } from '@/utils/auth'

declare global {
  interface Window {
    WisprConcierge?: {
      init(opts: Record<string, unknown>): void
      destroy(): void
    }
  }
}

// V1 is the always-open bottom bar. Concierge owns its UI and validates the active provider token server-side.
const CONCIERGE_SRC = 'https://concierge.wisprflow.com/v1/widget.js'
const LOADER_ID = 'wispr-concierge-loader'

function widgetOptions(email: string) {
  return {
    getToken: getAccessToken,
    page: () => document.title || window.location.pathname,
    userEmail: email,
  }
}

export function initConciergeWidget(email: string | undefined): void {
  // Logged out: tear down anything already loaded so the widget never lingers
  // over a logged-out screen.
  if (!email) {
    window.WisprConcierge?.destroy()
    return
  }

  // Already loaded this session (e.g. log out then back in without a reload):
  // re-init directly rather than injecting the script again.
  if (window.WisprConcierge) {
    window.WisprConcierge.init(widgetOptions(email))
    return
  }
  if (document.getElementById(LOADER_ID)) return

  const script = document.createElement('script')
  script.id = LOADER_ID
  script.src = CONCIERGE_SRC
  script.async = true
  script.onload = () => window.WisprConcierge?.init(widgetOptions(email))
  script.onerror = () => console.error('[concierge] widget failed to load')
  document.body.appendChild(script)
}

// The widget lives in document.body, outside React, so it survives AppLayout
// unmounting on logout. Callers must tear it down explicitly.
export function teardownConciergeWidget(): void {
  window.WisprConcierge?.destroy()
}
